import { Lead } from '@/types';
import { cn } from '@/lib/utils';
import { useLeadsStore } from '@/store/leadsStore';
import { LeadProfileSidebar } from './inbox/LeadProfileSidebar';

interface LeadDrawerProps {
  lead: Lead | null;
  open: boolean;
  onClose: () => void;
  onDeleted?: () => void;
}

export function LeadDrawer({ lead, open, onClose, onDeleted }: LeadDrawerProps) {
  const updateLeadLocally = useLeadsStore(state => state.updateLeadLocally);
  const removeLeadLocally = useLeadsStore(state => state.removeLeadLocally);

  if (!open || !lead) return null;

  return (
    <LeadProfileSidebar 
      lead={lead} 
      onUpdate={(updatedData) => {
        if (updatedData) {
          updateLeadLocally(lead.id, updatedData);
        }
      }}
      onDelete={() => {
         removeLeadLocally(lead.id);
         onClose();
         onDeleted?.();
      }}
      onClose={onClose}
    />
  );
}
